import type { AppKitNetwork } from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { injected } from "wagmi";
import { APP_METADATA, getAppKitConfig, getProjectId, NETWORK_CONFIG } from "./config";

// Module-level state for lazy initialization
let wagmiAdapter: WagmiAdapter | null = null;
let isAppKitInitialized = false;

/**
 * Initializes the Wagmi adapter for AppKit integration
 * Uses lazy initialization to avoid execution during module import
 */
export function initializeWagmiAdapter(): WagmiAdapter {
  if (!wagmiAdapter) {
    wagmiAdapter = new WagmiAdapter({
      networks: NETWORK_CONFIG.supportedNetworks as unknown as [AppKitNetwork, ...AppKitNetwork[]],
      projectId: getProjectId() || "",
      connectors: [injected()],
    });
  }
  return wagmiAdapter;
}

/**
 * Initializes AppKit with the provided Wagmi adapter
 * Uses guard to ensure AppKit is only initialized once
 */
export function initializeAppKit(adapter: WagmiAdapter): void {
  if (!isAppKitInitialized) {
    createAppKit({
      adapters: [adapter],
      networks: NETWORK_CONFIG.supportedNetworks as unknown as [AppKitNetwork, ...AppKitNetwork[]],
      projectId: getProjectId() || "",
      metadata: APP_METADATA,
      features: getAppKitConfig().features,
      themeVariables: getAppKitConfig().themeVariables,
      termsConditionsUrl: getAppKitConfig().termsConditionsUrl,
      privacyPolicyUrl: getAppKitConfig().privacyPolicyUrl,
    });
    isAppKitInitialized = true;
  }
}
